module.exports = __webpack_public_path__ + "media/images/prolab-logo-e69949cb.png";